export default __webpack_public_path__ + "static/team-extension-98df9d3a39aa1b886a34bacaf6f16adb.svg";